// extracted by mini-css-extract-plugin
module.exports = {"container":"DetailPage_container__qbKFm","small":"DetailPage_small__ej_5y"};